module.exports = __webpack_public_path__ + "assets/absorb.e1978769.svg";